import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { push } from 'react-router-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { selectAllHorses } from '../reducers/horsesReducer';
import { selectSale } from '../reducers/salesReducer';
import { performSearch, setActiveSearch } from '../actions/horseActions';
import { map, filter } from 'ramda';

class SearchElement extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            value: '',
            suggestions: [],
            selectValue: props.params && props.params.column ? props.params.column : 'horses',
      };
    };

    getSuggestions = (value, horses) => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;
        const items = inputLength === 0 || this.state.selectValue === 'horses' ? [] :
        filter(horse =>
            horse[this.state.selectValue] && horse[this.state.selectValue].toLowerCase().slice(0, inputLength) === inputValue
        )(horses);

        return [...new Set(map(item => item[this.state.selectValue])(items))];
    };

    getSuggestionValue = suggestion => suggestion;

    renderSuggestion = suggestion => (
        <span>
            {suggestion}
        </span>
    );

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value, this.props.horses)
        });
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    onSuggestionSelected = () => {
        const { setSearchingState } = this.props;
        setSearchingState(true);
    }

    render() {
        const { value, suggestions, selectValue } = this.state;
        const { searchHorses, setSearchingState, sale, search, pushLocation, params = {}, enhanced = false } = this.props;
        let {
            column = null,
            filter = null
        } = params;

        let input, select = null;
        const className = global.drupalSettings.catalogues.is_admin ? 'logged-in-search' : '';

        const onChange = (event, { newValue }) => {
            this.setState({
                value: newValue,
            });
            searchHorses(selectValue, newValue);
            setSearchingState(false);
        };

        const inputProps = {
            placeholder: 'Search...',
            value: filter ? filter : value,
            onChange: onChange,
            ref: (i) => { input = i; return input; },
            className: "form-control search",
            id: "catalog-search",
            size: "24",
        };



      return (
          <form className={`form-inline search-form ${className}`}  onSubmit={e => { e.preventDefault(); }}>
              <div className="form-group row">
                <div className="input-group col-4">
                  <label className="sr-only" htmlFor="catalog-search">Search</label>
                  <select
                      className="form-control"
                      id="searchTerm"
                      ref={(i) => { select = i; return select; }}
                      onChange={(event) => {
                            this.setState({
                                selectValue: select.value,
                            });
                            searchHorses(select.value, value);
                      }}
                      value={this.state.selectValue}
                  >
                      <option value="horses">All</option>
                      <option value="sire">Sire</option>
                      <option value="dam">Dam</option>
                      <option value="consignor_name">Consignor</option>
                      <option value="foaled">Foaled</option>
                      {sale.show_purchaser && sale.show_results && <option value="purchaser">Buyer</option>}
                      {sale.show_covering_sire && <option value="covering_sire">Covering Sire</option>}
                  </select>
                  </div>
                  <div className="input-group col-8">
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={inputProps}
                        onSuggestionSelected={this.onSuggestionSelected}
                        />
                    <span className="input-group-addon" id="basic-addon2">
                      {this.state.value || filter || column ? (
                          <FontAwesomeIcon
                            onClick={() => {
                                searchHorses(select.value, '');
                                this.setState({value: '', selectValue: 'horses'});
                            }} 
                            className="control-button" icon={['fas', 'times']} 
                          />
                        ) : (
                            <FontAwesomeIcon className="control-button" icon={['fas', 'search']} />
                      )}
                    </span>
                </div>
              </div>
          </form>
      );
    }
  }

  const mapState = (state) => {
    return {
        search: state.search,
        sale: selectSale(state),
        horses: selectAllHorses(state),
    };
  };

  const mapDispatch = ((dispatch) => {
    return {
        searchHorses: (field, value) => dispatch(performSearch(field, value)),
        setSearchingState: (isSearching) => dispatch(setActiveSearch(isSearching)),
        pushLocation: location => dispatch(push(location)),
    };
  });

  export default connect(mapState, mapDispatch)(SearchElement);